export default "__VITE_ASSET__ZZVWpAnp__"